import { Injectable } from '@angular/core'
import { MatDialog } from '@angular/material/dialog'
import { SearchResultsDialogComponent } from './search-results-dialog.component'
import { SearchResultType } from '../search/search-result-type'
import { DialogService } from '@tokeet-frontend/tv3-platform'

@Injectable({ providedIn: 'root' })
export class SearchResultsDialogService {
  constructor(private dialog: DialogService) {}

  open(type: SearchResultType, results: any[]) {
    return this.dialog.openVariableDialog(SearchResultsDialogComponent, {
      width: '900px',
      data: { type, results },
    })
  }
}
